import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { KanbanInstancia, tarefaTemTimer, calcularTempoRestante } from "./kanbanTypes";

type Props = {
    instancias: KanbanInstancia[];
    onClick: () => void;
};

export default function ContadorAtrasadas({ instancias, onClick }: Props) {
    const temAlgumTimer = useMemo(
        () => instancias.some(i => i.tarefas.some(tarefaTemTimer)),
        [instancias]
    );

    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!temAlgumTimer) return;
        const interval = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [temAlgumTimer]);

    const total = useMemo(() => {
        let count = 0;
        for (const inst of instancias) {
            for (const t of inst.tarefas) {
                if (!tarefaTemTimer(t)) continue;
                const info = calcularTempoRestante(t, now);
                if (info && info.expirado) count++;
            }
        }
        return count;
    }, [instancias, now]);

    return (
        <Box
            onClick={() => { if (total > 0) onClick(); }}
            sx={{
                display: "flex", alignItems: "center", gap: 0.8,
                bgcolor: total > 0 ? "#ffebee" : "#f5f5f5",
                border: "1px solid",
                borderColor: total > 0 ? "#ef5350" : "#bdbdbd",
                borderRadius: 2, px: 1.5, py: 0.6,
                cursor: total > 0 ? "pointer" : "default",
                transition: "opacity 0.2s",
                "&:hover": total > 0 ? { opacity: 0.85 } : {},
            }}
        >
            <WarningAmberIcon sx={{ fontSize: 20, color: total > 0 ? "#d32f2f" : "#9e9e9e" }} />
            <Typography fontSize={14} fontWeight={700} color={total > 0 ? "#d32f2f" : "#757575"}>
                {total}
            </Typography>
            <Typography fontSize={13} color={total > 0 ? "#d32f2f" : "#757575"}>
                atrasada{total !== 1 ? "s" : ""}
            </Typography>
        </Box>
    );
}
